import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section id="history">
  <h1>How God Moved During the European Congress on Evangelism</h1>
  <p>Over 1,000 Christian leaders from more than 55 countries and territories came together this past May in Berlin to be equipped and encouraged in their calling as evangelists.</p>
  <p>Speakers from across Europe and around the globe focused on the power and challenge of Romans 1:16: <em>“I am not ashamed of the Gospel ...”</em></p>
  <p>“My heart is burning,” a participant shared afterward. “I can't wait to get home.”</p>
    </section>
    <section id="video">
  <div className="flex-video">
    <iframe className="responsive-iframe" type="text/javascript" src='https://cdnapisec.kaltura.com/p/650742/sp/65074200/embedIframeJs/uiconf_id/49982243/partner_id/650742?iframeembed=true&playerId=kaltura_player_1694532980&entry_id=1_fw9vxucs' style={{
          "width": "100%",
          "height": "100%"
        }} allowFullScreen webkitallowfullscreen mozAllowFullScreen allow="autoplay *; fullscreen *; encrypted-media *" frameBorder="0"></iframe>
  </div>
    </section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      